import AlignCenter from "../../../icons/AlignCenter";
import AlignLeft from "../../../icons/AlignLeft";
import AlignRight from "../../../icons/AlignRight";

export const ALIGNMENT_OPTIONS = [
  { icon: AlignLeft, value: "left" },
  { icon: AlignCenter, value: "center" },
  { icon: AlignRight, value: "right" },
];
